import type { FaireProductEntity } from "../../entity_types/product";

export const nopalera_2: FaireProductEntity = {
  token: "nopalera-2",
  type: "product",
  name: "Nopal Body Bar",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bf3ac19bc2e67ba5ee797fbca51c70beb5715569e7fd7e5230a18c8a7b859264.webp",
  priceDollars: 18,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.5,
  dimensions: {
    width: 2.5,
    height: 3.5,
    depth: 1.5,
  },
  description: "Nopal cactus soap bar",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "organic", "natural", "cactus"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
